import { render, staticRenderFns } from "./PatentAnnuityWillPayList.vue?vue&type=template&id=2e6641f1&"
import script from "./PatentAnnuityWillPayList.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityWillPayList.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnuityWillPayList.vue?vue&type=style&index=0&id=2e6641f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports